import { TrialLoadingIcon } from '../TrialLoadingIcon'
import { useTrial } from '../TrialProvider'

interface TrialLoadingProps {
	title: string
}

export function TrialLoading({ title }: TrialLoadingProps) {
	const { loadingMessage: message } = useTrial()

	return (
		<div className="w-full pt-8 lg:pt-12">
			<TrialLoadingIcon />
			<div className="text-center">
				<h2 className="text-2xl font-medium mb-6">{title}</h2>
				{message && <p>{message}</p>}
			</div>
		</div>
	)
}
